import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import { Dropdown } from 'primereact/dropdown';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioUsuario from '../servicios/ServicioUsuario';
import servicioCliente from '../servicios/ServicioTcCliente';

export class AdministradorUsuario extends React.Component {
    constructor() {
        super();
        this.state = {
            usuario: {},
            mostraModalCliente: false,
            mostrarModalConfirmacion:false,
            erroresRequeridos: {},
            errores:{},
            paginacion: { registrosPorPagina: 20,join:{"tcPerfil":"p","tcCliente":"c"},restricciones:{"alias_p.rol":"administrador"}},
            inicio: 0,
            listadoClientes:[],
            botonEditar:false

        }
    }
    componentDidMount() {
        this.obtenerPagina();
        this.obtenerClientes();
     }



     obtenerClientes(){
        let paginacion= { registrosPorPagina: 20}
        servicioCliente.paginacion(paginacion).then(response=>{
            let lista=response.data.objeto.datos;
            console.log();
        this.setState({listadoClientes:lista});
        })
     }
     cambiaPagina(event) {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerPagina();
    }
    obtenerPagina() {
        let { paginacion } = this.state;
       
       
        servicioUsuario.paginacion(paginacion).then((response) => {
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });

            if (response.data.error === false)
                this.setState({ paginacion: response.data.objeto });

        }).catch((error) => {
            if (error)
                return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });
    }


    mostrarModal() {
       
        this.setState({ mostraModalCliente: true });
    }
    resetEstados() {
        this.setState({
            mostrarModalConfirmacion:false,
            mostraModalCliente: false,
            usuario:{}
        });
    }
    guardar() {
        let { usuario} = this.state;
        const validacion = this.validarFormulario(usuario);
        this.setState({ errores: validacion });
        if (!Object.keys(validacion).length) {
            var usuarioEnvio = JSON.parse(JSON.stringify(usuario));
            servicioUsuario.guardar_usuario_adninistrador(usuarioEnvio).then(response=>{
                this.growl.show({ life: 6000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
              if (response.data.error === false) {
                   this.obtenerPagina();
                   this.resetEstados();
                }
            }).catch((error) => {
            console.log(error);
            });
        }

    }

    editar=()=>{
        let{usuario}=this.state;
        servicioUsuario.editar_usuario_adninistrador(usuario).then(response=>{
            this.growl.show({ life: 6000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
            if (response.data.error === false) {
                 this.obtenerPagina();
                 this.resetEstados();
              }
        });
    }
    eliminar = () => {
        let { usuario} = this.state;
        servicioUsuario.eliminar_usuario_admiminstrador(usuario).then((response) => {
            this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
            if (response.data.error === false) {
                this.resetEstados();
                this.obtenerPagina();
            }
        }).catch((error) => {
     });
    }
    preeditar(objeto) {
        var usuarioEditar = JSON.parse(JSON.stringify(objeto));
        this.setState({ mostraModalCliente: true, usuario: usuarioEditar,botonEditar:true });
    }
    validarFormulario = (usuario) => {
        const errores = {};

        if (!usuario.usuario)
        errores.usuario = "Usuario es requerido";
        if (!usuario.correo)
        errores.correo = "Correo es requerido";
        if (!usuario.tcCliente) {
            errores.tcCliente = "Cliente es requerido";
        }
        return errores;
    };
    asignarValores = (event) => {
    servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, false);
    }
    plantillaOpciones(rowData, column) {
        return <div className="p-grid">

            <div className="p-col-12 p-md-2">
                <Button type="button" icon="pi-md-edit" onClick={(e) => this.preeditar(column.rowData)} className="p-button-warning" name="editar"
                    tooltip="editar" >
                </Button>
                <Button type="button" icon="pi-md-delete" onClick={(e) => this.mostrarModalEliminar(column.rowData)} className="p-button-danger" name="eliminar"
                    tooltip="eliminar" >
                </Button>

            </div>
          
        </div>;
    }
    mostrarModalEliminar = (objeto) => {
        this.setState({ mostrarModalConfirmacion: true, usuario: objeto });
    }
    formatoEstado = (rowData, column) => {
        if (rowData.estado == 1)
            return <p style={{ backgroundColor: '#33ff4c', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Activo</p>;
        else
            return <p style={{ backgroundColor: '#f008', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Desactivado</p>
    }
    render() {
        let { usuario,errores,listadoClientes, paginacion, inicio,botonEditar} = this.state;
        const pieDialogo = <div className="ui-dialog-buttonpane p-clearfix">
        {botonEditar ? <Button label="Editar" icon="pi-md-check" onClick={this.editar} />:<Button label="Guardar" icon="pi-md-check" onClick={this.guardar.bind(this)} />}
        
        <Button label="Cancelar" icon="pi-md-close" onClick={this.resetEstados.bind(this)} className="p-button-danger " />
    </div>;
     const dialogFooterConfirmacionEliminar = (
        <div>
            <Button icon="pi-md-check" onClick={this.eliminar} label="Si estoy seguro" className="teal-btn flat-btn" />
            <Button icon="pi-md-close" onClick={() => this.setState({ cliente: {}, mostrarModalConfirmacion: false, errores: {} })} label="No estoy seguro" className="p-button-danger flat-btn" />
        </div>
    );
        return (
            <div className="p-grid">
                <Growl ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <h1>Usuarios Administradores</h1>
                        <div className="p-fluid p-grid">
                            <div className="p-col-12 p-md-4">
                                <Button className="p-button-Primary p-button-raised" label="Agregar"
                                    icon="pi-md-plus" tooltip={"Agregar nuevo"} onClick={this.mostrarModal.bind(this)} />
                            </div>


                        </div>
                    </div>
                </div>
                <Dialog visible={this.state.mostraModalCliente} header="Datos del Cliente" footer={pieDialogo} onHide={this.resetEstados.bind(this)}>
                    <h4>Los campos con (*) son obligatorios, por favor captura los datos del cliente</h4>
                    <div className="p-grid p-fluid ">
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="usuario">* Nombre Usuario:</label>
                        </div>
                        <div className="p-col-12 p-md-4">
                            <InputText id="usuario" name="usuario.usuario" className={errores.usuario ? 'p-error' : ''} value={usuario.usuario || ''} onChange={this.asignarValores.bind(this)}/>
                            {errores.usuario ? <div><br /> <Message severity="error" text={errores.usuario} /> </div> : null}
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="correo">* Correo:</label>
                        </div>
                        <div className="p-col-12 p-md-4">
                            <InputText id="correo" name="usuario.correo" className={errores.correo ? 'p-error' : ''} value={usuario.correo || ''} onChange={this.asignarValores.bind(this)}/>
                            {errores.correo ? <div><br /> <Message severity="error" text={errores.correo} /> </div> : null}
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="estado">* Cliente:</label>
                        </div>
                        <div className="p-col-12 p-md-4">
                            <Dropdown id="tcCliente" name="usuario.tcCliente" options={listadoClientes} value={usuario.tcCliente || ''} onChange={this.asignarValores} placeholder="Selecciona" optionLabel="nombre" className={errores.estado ? 'p-error' : ''} autoWidth={false}/>
                            {errores.tcCliente ? <div> <Message severity="error" text={errores.tcCliente} /> </div> : null}
                        </div>
                    </div>
                </Dialog>
                <Dialog header="Confirmación" visible={this.state.mostrarModalConfirmacion} modal={true} style={{ width: '30vw' }} footer={dialogFooterConfirmacionEliminar} onHide={() => this.setState({ cliente: {}, mostrarModalConfirmacion: false, errores: {} })}>
                <h2>¿Estás seguro de eliminar el cliente?</h2>
            </Dialog>
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <DataTable value={paginacion.datos} editable={true} selectionMode="single" responsive={true} header="Clientes" >
                            <Column field="usuario" header="Usuario" autoLayout={true} />
                            <Column field="correo" header="Correo" autoLayout={true} />
                            <Column field="tcCliente.nombre" header="Cliente" autoLayout={true} /> 
                            <Column header="Opciones" body={this.plantillaOpciones.bind(this)} autoLayout={true} />
                        </DataTable>
                        <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                    </div>
                </div>
            </div>

        )
    }
}
